import { Box, Paper, Typography, Link } from "@mui/material";

// Multi-lingual support
import { t } from "i18next";

// Page not found component
const PageNotFound: React.FC = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <Paper
          sx={{
            width: "700px",
            padding: 4,
            textAlign: "center",
            borderRadius: 4,
          }}
        >
          <Typography
            fontSize={120}
            fontWeight={600}
            sx={{ color: "risinblack.main" }}
          >
            404
          </Typography>

          <Typography sx={{ color: "risinblack.main" }}>
            <b>{t("pageNotFound.oopsText")}</b>{" "}
            {t("pageNotFound.pageNotFoundInfo")}
          </Typography>
          <Link
            marginY={3}
            fontWeight={600}
            href="/verifyuser"
            display={"block"}
          >
            {t("pageNotFound.goToHomePage")}
          </Link>
        </Paper>
      </Box>
    </>
  );
};

export default PageNotFound;
